// Keeps a b-tabs index in the URL (?tab=<key>) so that going back from a detail
// page lands on the same tab. The component declares:
//   tabQuery: { keys: ["a", "b"], model: "activeTabIndex" }
// where `model` is the data property bound to b-tabs v-model.
export default {
  created() {
    const { keys, model } = this.$options.tabQuery;
    const index = keys.indexOf(this.$route.query.tab);
    if (index >= 0) this[model] = index;

    this.$watch(model, current => {
      const tab = keys[current];
      if (!tab || this.$route.query.tab === tab) return;
      // replace (not push) so each tab click doesn't add a history entry
      this.$router
        .replace({ query: { ...this.$route.query, tab } })
        .catch(() => {});
    });
  },
  watch: {
    // e.g. a sidebar link to this same page without ?tab resets to the first tab
    "$route.query.tab"(tab) {
      const { keys, model } = this.$options.tabQuery;
      const index = keys.indexOf(tab);
      this[model] = index >= 0 ? index : 0;
    },
  },
};
